import {createSlice} from "@reduxjs/toolkit"
const userSlice = createSlice({
    name:"user",
    initialState:{
        uid: "default-user",
        email: "guest@netflixgpt.com",
        displayName: "Guest User",
        photoURL: "https://avatars.githubusercontent.com/u/12345"
    },
    reducers:{
          addUser:(state, action)=>{
             return action.payload
         },
         removeUser:(state,action)=>{
            return {
                uid: "default-user",
                email: "guest@netflixgpt.com",
                displayName: "Guest User",
                photoURL: "https://avatars.githubusercontent.com/u/12345"
            };
         }
     }

})
export default userSlice.reducer;
export const {addUser, removeUser}= userSlice.actions